<template>
    <v-row
        :class="rowClass"
        align="center"
        no-gutters
    >
        <div class="subtitle-1 font-weight-bold">
            <span
                v-if="itemCount > 0"
            >
                {{ itemCount }}
            </span>
            <div
                class="d-inline-block"
                :class="itemCount > 0 ? 'text-lowercase-first-letter' : 'text-uppercase-first-letter'"
            >
                {{ itemLabel }}
            </div>
        </div>
        <div v-if="showButton" class="d-inline ml-3">
            <action-button test-id="app-store-list-header-add-button" @click="$emit('add-item')">
                {{ addLabel }}
            </action-button>
        </div>
    </v-row>
</template>

<script>
export default {
    name: "AppStoreListHeader",
    props: {
        itemCount: {
            type: Number,
            default: null
        },
        itemLabel: {
            type: String,
            default: null
        },
        addLabel: {
            type: String,
            default: null
        },
        showButton: {
            type: Boolean,
            default: false
        },
        rowClass: {
            type: String,
            default: "pl-4"
        }
    }
}
</script>
